import { Box, Typography } from "@mui/material";
import { MainContainer } from "../../components/container/MainContainer";
import { PageTitleContainer } from "../../components/container/PageTitleContainer";
import muiSytle from "../../style/components-style/muiStyle";

const SettingDashboard = () => {
  return (
    <MainContainer>
      <PageTitleContainer>
        <Box>
          <Box>
            <Typography variant="Page Title">Setting</Typography>
          </Box>
          <Box>
            <Typography variant="Page Subtitle">Setting</Typography>
          </Box>
        </Box>
      </PageTitleContainer>
      <Box></Box>
    </MainContainer>
  );
};
export default SettingDashboard;
